/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { cn } from "../../lib/utils";

type SpinnerSize = "xs" | "sm" | "md" | "lg";

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizes: Record<SpinnerSize, { size: string; border: string }> = {
  xs: { size: "14px", border: "2px" },
  sm: { size: "18px", border: "2px" },
  md: { size: "24px", border: "3px" },
  lg: { size: "44px", border: "4px" },
};

export function Spinner({ size = "md", className }: SpinnerProps) {
  const { size: px, border } = sizes[size];
  return (
    <span
      role="status"
      aria-label="Loading"
      style={
        { "--spinner-size": px, "--spinner-border": border } as React.CSSProperties
      }
      className={cn("loader-ring text-accent", className)}
    />
  );
}
